import { CheckCircle, Clock, Play, Settings, UserCheck } from 'lucide-react'
import { useMemo } from 'react'

import { Badge } from 'slab'
import { type PartnersEmployerStatus } from 'utils/web_api.schemas'

interface OnboardingStatusBadgeProps {
  status: PartnersEmployerStatus
}

const OnboardingStatusBadge = ({ status }: OnboardingStatusBadgeProps) => {
  const groupedStatus = useMemo(() => {
    if (!status) {
      return {
        label: 'Unknown',
        type: 'neutral' as const,
        icon: Clock,
      }
    }

    switch (status) {
      case 'open':
        return {
          label: 'Not Started',
          type: 'neutral' as const,
          icon: Clock,
        }
      case 'launched':
      case 'quoted':
      case 'quote_accepted':
        return {
          label: 'In Progress',
          type: 'warning' as const,
          icon: Play,
        }
      case 'payroll_connected':
        // TODO: Clean up this quick fix - payroll_connected currently shows as "Payroll Connected"
        // for all employers, but should be "Not Started" for platform employers and "Almost Complete"
        // for self-serve employers. See: https://linear.app/thatch/issue/MM-152/follow-up-refactor-employeronboarding-status
        return {
          label: 'Payroll Connected',
          type: 'info' as const,
          icon: Settings,
        }
      case 'bank_account_created':
        return {
          label: 'Almost Complete',
          type: 'info' as const,
          icon: UserCheck,
        }
      case 'completed':
        return {
          label: 'Complete',
          type: 'success' as const,
          icon: CheckCircle,
        }
      default:
        return {
          label: 'Unknown',
          type: 'neutral' as const,
          icon: Clock,
        }
    }
  }, [status])

  const { label, type, icon: Icon } = groupedStatus

  return (
    <Badge type={type} leftIcon={Icon}>
      {label}
    </Badge>
  )
}

export default OnboardingStatusBadge
